<div class="main-container" [class.manage]="mode === 'manage'">
  <div class="pages-container" *ngIf="isLoaded; else spinner">
    <app-new-page-item
      *ngFor="let fbPage of listFBPages; trackBy: trackById"
      [class.selected]="fbPage.id === selectedPage"
      [page]="fbPage"
      [mode]="mode"
      [canLink]="canLink(fbPage)"
      (click)="select(fbPage)"
      (disconnect)="disconnect(fbPage, 'facebook')"
      (link)="link(fbPage)"
    ></app-new-page-item>
    <app-new-page-item
      *ngFor="let instaPage of listInstagramPages; trackBy: trackById"
      [class.selected]="instaPage.id === selectedPage"
      [page]="instaPage"
      [mode]="mode"
      [canLink]="canLink(instaPage)"
      (click)="select(instaPage)"
      (disconnect)="disconnect(instaPage, 'instagram')"
      (link)="link(instaPage)"
    ></app-new-page-item>
  </div>
  <ng-template #spinner>
    <app-tiny-bot-spinner [class.mb-2]="mode === 'select'" *ngIf="!isLoaded"></app-tiny-bot-spinner>
  </ng-template>
  <ng-container *ngIf="mode === 'select'">
    <div *ngIf="isLoaded && (listFBPages?.length || listInstagramPages?.length)" class="or my-1">
      <hr />
      &nbsp;or&nbsp;
      <hr />
    </div>
    <div class="pages-container">
      <app-new-page-item class="add" [page]="fbAddPage" [mode]="'add'" (click)="getMore('facebook')"></app-new-page-item>
      <app-new-page-item class="add" [page]="instaAddPage" [mode]="'add'" (click)="getMore('instagram')"></app-new-page-item>
    </div>
  </ng-container>
</div>

<!-- Separated channels display -->
<!-- <div class="main-container" [class.manage]="mode === 'manage'" *ngIf="isLoaded; else spinner">
  <div class="channel-container">
    <div class="channel-title"><img src="assets/img/icons/facebook-icon.png" /> Facebook</div>
    <div class="pages-container">
      <app-new-page-item
        *ngFor="let fbPage of listFBPages; trackBy: trackById"
        [class.selected]="fbPage.id === selectedPage"
        [page]="fbPage"
        [mode]="mode"
        (click)="select(fbPage)"
        (disconnect)="disconnect(fbPage, 'facebook')"
      ></app-new-page-item>
      <div *ngIf="mode === 'select'" (click)="getMore('facebook')">+Add other pages</div>
    </div>
  </div>
  <div class="channel-container separator">
    <div class="channel-title"><img src="assets/img/icons/instagram-icon.png" /> Instagram</div>
    <div class="pages-container">
      <app-new-page-item
        *ngFor="let instaPage of listInstagramPages; trackBy: trackById"
        [class.selected]="instaPage.id === selectedPage"
        [page]="instaPage"
        [mode]="mode"
        (click)="select(instaPage)"
        (disconnect)="disconnect(instaPage, 'instagram')"
      ></app-new-page-item>
      <div *ngIf="mode === 'select'" (click)="getMore('instagram')">+Add other accounts</div>
    </div>
  </div>
</div> -->
